module.exports = __webpack_public_path__ + "img/roles-management.179ff28b.png";